import get from 'lodash/get';

export default function getRecentSearches(organization) {
  const object = JSON.parse(localStorage.getItem('recentSearches'));

  const recent = get(object, `${organization}`, []);
  return recent.reverse();
}
